import { ref, watch, onMounted, onBeforeUnmount } from 'vue';

export const useInterval = ({ ms = 60000, handler = null, immediate = false } = {}) => {
    const intervalTimes = ref(0);
    const intervalEnabled = ref(true);
    const intervalLastCall = ref(null);
    const intervalRunning = ref(!!immediate);
    const intervalActive = ref(null);

    const intervalStartUpdater = () => {
        if (!intervalEnabled.value) return;

        intervalActive.value = setInterval(() => {
            if (typeof handler === 'function') {
                handler();
            }

            intervalTimes.value++;
            intervalLastCall.value = new Date();
        }, ms);
    };

    const intervalStopUpdater = () => {
        if (intervalActive.value) {
            clearInterval(intervalActive.value);
            intervalActive.value = null;
        }
    };

    const intervalDisable = () => {
        intervalEnabled.value = false;
        intervalRunning.value = false;
        intervalStopUpdater();
    };

    watch(intervalRunning, (running) => {
        if (running && intervalEnabled.value) {
            intervalStartUpdater();
        } else {
            intervalStopUpdater();
        }
    });

    onMounted(() => {
        if (intervalRunning.value) {
            intervalStartUpdater();
            if (typeof handler === 'function') {
                handler();
            }
        }
    });

    onBeforeUnmount(() => {
        intervalStopUpdater();
    });

    return {
        intervalTimes,
        intervalEnabled,
        intervalLastCall,
        intervalRunning,
        intervalActive,
        intervalStartUpdater,
        intervalStopUpdater,
        intervalDisable,
    };
};
